import { AccessAlarm, Airplay, ThumbUp } from "@material-ui/icons";
import CreatedByField from "../../Components/ReferenceFields/CreatedBy/CreatedByField";
import { Chip } from "@material-ui/core";
import * as React from "react";
import { CoreInfoRequestStatusEnum } from "../../../src/Enums/CoreInfoRequestStatusEnum";
import { formatDate } from "../../../src/Helper/MomentHelper";

const CoreInfoRequestInfoChip = ({ record }) => {
  let icon, text;
  if (record.status === CoreInfoRequestStatusEnum.WaitingCustomer) {
    icon = <Airplay />;
    text = [
      "Core Info Request Waiting For Customer Created",
      " by ",
      <CreatedByField record={record} link={false} source="createdBy" />,
      " ",
      formatDate(record.createdDate),
    ];
  } else if (record.status === CoreInfoRequestStatusEnum.Accepted) {
    icon = <ThumbUp />;
    text = [
      "Core Info Request Accepted",
      " by ",
      <CreatedByField record={record} link={false} source="updatedBy" />,
      " ",
      formatDate(record.accomplishDate),
    ];
  } else if (record.status === CoreInfoRequestStatusEnum.Responded) {
    icon = <AccessAlarm />;
    text = [
      "Core Info Request Responded",
      " by ",
      <CreatedByField record={record} link={false} source="updatedBy" />,
      " ",
      formatDate(record.RespondedDate),
    ];
  }
  return <Chip key={88889999} color="primary" variant="outlined" label={text} icon={icon} />;
};

export default CoreInfoRequestInfoChip;
